// extracted by mini-css-extract-plugin
export var bold = "title-module--bold--f6862";
export var light = "title-module--light--3a303";
export var title = "title-module--title--92d6c";